import { render, staticRenderFns } from "./IlpaVideos.vue?vue&type=template&id=7afcb16d&scoped=true"
import script from "./IlpaVideos.vue?vue&type=script&lang=js"
export * from "./IlpaVideos.vue?vue&type=script&lang=js"
import style0 from "./IlpaVideos.vue?vue&type=style&index=0&id=7afcb16d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcb16d",
  null
  
)

export default component.exports